import { WorkArea } from '@this+that/models';

export const WORK_AREA_LABEL_KEYS: Record<WorkArea, string> = {
  [WorkArea.ENGINEERING]: 'discover.areas.engineering',
  [WorkArea.HR_PEOPLE]: 'discover.areas.hr_people',
  [WorkArea.SALES]: 'discover.areas.sales',
  [WorkArea.MARKETING]: 'discover.areas.marketing',
  [WorkArea.SUPPORT_CS]: 'discover.areas.support_cs',
  [WorkArea.FINANCE]: 'discover.areas.finance',
  [WorkArea.OPERATIONS]: 'discover.areas.operations',
  [WorkArea.LEGAL]: 'discover.areas.legal',
  [WorkArea.FOUNDER_LEADERSHIP]: 'discover.areas.founder_leadership',
};
